// extracted by mini-css-extract-plugin
export var highlightC = "NavDropdown-module--highlightC--3d036";
export var item = "NavDropdown-module--item--fe322";
export var linkActive = "NavDropdown-module--linkActive--90426";
export var nShown = "NavDropdown-module--nShown--7b9b5";
export var open = "NavDropdown-module--open--549e5";
export var root = "NavDropdown-module--root--23ab2";
export var tag = "NavDropdown-module--tag--24abf";